<script setup lang="ts">
import { ChatBubbleLeftRightIcon, ShieldCheckIcon, UserGroupIcon } from '@heroicons/vue/24/outline'

defineProps<{
  page: string
}>()

const trustItems = [
  { icon: UserGroupIcon, text: 'Plus de 1 200 membres dans la communauté' },
  { icon: ChatBubbleLeftRightIcon, text: 'Avis écrits et vidéo' },
  { icon: ShieldCheckIcon, text: 'Garantie satisfait ou remboursé 60 jours' },
]
</script>

<template>
  <section class="border-b border-slate-200 bg-white" aria-label="Éléments de confiance">
    <div class="mx-auto flex max-w-7xl flex-col items-stretch gap-4 px-4 py-5 sm:px-6 lg:flex-row lg:items-center lg:px-8">
      <div class="grid flex-1 gap-3 sm:grid-cols-3">
        <div v-for="item in trustItems" :key="item.text" class="flex items-center gap-2.5 text-sm font-semibold text-slate-700">
          <component :is="item.icon" class="h-5 w-5 shrink-0 text-green-cucumber-600" aria-hidden="true" />
          <span>{{ item.text }}</span>
        </div>
      </div>
      <MarketingCta
        href="/#avis"
        label="Voir les avis Senja"
        :page="page"
        section="trust-strip"
        destination="anchor"
        variant="secondary"
        class="w-full shrink-0 lg:w-auto"
      />
    </div>
  </section>
</template>
